import { IEvolution } from './ievolution';
export interface IEvolutionState {
    evolution: IEvolution,
    evolutions: Array<IEvolution>,
    error?: any
}
